function congcontact() {
    $('#contacts_form').ajaxSubmit();

    let text_cong = $('#contacts_form #contacts_form_cong').html();

    $('#modal_info_container .modal-body .modal_content').html(text_cong);
    $('#modal_info_container').modal();

    setTimeout(function() {
        $("#contacts_form .reset_input").val('');
        //$('#contacts_form_congratulation').hide();
        //$("#contacts_form").show();
    }, 2000);

    return true;
}



$(document).ready(function() {
    //add email styles//
    if($('#input-email').length) {

        if ($('#input-email').val().length > 0) {
            $(this).addClass('notEmpty');
        }
        $('#input-email').on("change paste keyup", function () {
            if ($('#input-email').val().length > 0) {
                $(this).addClass('notEmpty');
            } else {
                $(this).removeClass('notEmpty');
            }
        });

    }
    /**************************************************************/
    $("#contacts_form #input-phone").mask("+38 (999) 999 99 99");

    $.validator.addMethod("valueNotEquals", function(value, element, arg){
        return arg !== value;
    }, "Value must not equal arg.");

    $("#contacts_form").validate({

        submitHandler: function() {
            congcontact();
        },
        errorPlacement: function(error, element) {
            if (element.attr("name") == "subject" )
                error.insertAfter(".selectric");
            else
                error.insertAfter(element);
        },
        rules: {
            name: {
                required: true
            },
            email: {
                required: true,
                email: true,
            },
            phone: {
                required: true,
            },
            enquiry: {
                required: true
            },

        },
        messages: {
            name: {
                required: "<span class='lang ua'>Введіть ім`я!</span>"
            },
            email: {
                required: "<span class='lang ua'>Введіть email!</span>",
                email: "<span class='lang ua'>Некоректний email!</span>",
            },
            phone: {
                required: "<span class='lang ua'>Введіть номер телефону!</span>",
            },
            enquiry: {
                required: "<span class='lang ua'>Введіть текст!</span>"
            },

        },
    });
});